import { withInstall } from '@vuesax-plus/utils'
import RadioGroup from './src/radio-group.vue'

export const VsRadioGroup = withInstall(RadioGroup)
export default VsRadioGroup

export * from './src/radio-group'
